import React from "react";
import moment from "moment";
import _ from "lodash";
import { Button, DatePicker, Menu, Typography } from "antd";
import { DateRangeQuickOptions, getStartAndEndDateForQuickOption, setEndOfTheDay, setStartOfTheDay } from "utils/dateUtils";
const { RangePicker } = DatePicker;
const { Title } = Typography;

class ColumnFilterDateRange extends React.Component {
  static defaultProps = {
    setQuickSelected: _.noop
  }
  state = {
    value: [],
    quickSelectedKey: [],
    changed: false,

  }
  ref = React.createRef()
  constructor(props){
    super(props);

    _.bindAll(
      this,
      "onChange",
      "clearFilter",
      "applyFilter",
      "onQuickSelect",
      "renderExtraFooter",
      'setPanelData',
      'disableFutureDates',
    )
    this.modes = undefined;
  }
  setValuesAsPerProps() {
    let { selectedKeys, quickSelected } = this.props;
    const { isUIDateRangeFilter } = this.props;
    //set value from props for frontend applied dateRange filter
    // selectedKeys has value [startDateUnixTimeStamp-endDateUnixTimeStamp]
    if(isUIDateRangeFilter){
      if(selectedKeys.length === 1){
        const selectedKeysForUIDateRange = [];
        const selectedKeysDateRange = selectedKeys[0].split('-');
        if(selectedKeysDateRange.length === 2){
          selectedKeysForUIDateRange.push(
            moment(Number(selectedKeysDateRange[0])).utc().format()
          );
          selectedKeysForUIDateRange.push(
            moment(Number(selectedKeysDateRange[1])).utc().format()
          );
        }
        selectedKeys = selectedKeysForUIDateRange;
      }
    } else {
      // if only 1 value, means quick options
      if(selectedKeys.length === 1){
        quickSelected = selectedKeys[0];
      }
    }
    const option = _.find(DateRangeQuickOptions, { label: quickSelected });
    this.setState({
      value: quickSelected ? getStartAndEndDateForQuickOption(option) : selectedKeys.map(key => moment(key)),
      quickSelectedKey: _.isUndefined(quickSelected) ? [] : [quickSelected],
      changed: false,
    });
  }
  componentDidMount(){
    this.setValuesAsPerProps();
  }
  componentDidUpdate(prevProps){
    const { visible } = this.props;
    if (prevProps.visible !== visible) {
      if (!visible) {
        this.setState({
          value: []
        });
      }
      if (visible) {
        this.setValuesAsPerProps();
      }
    }
  }
  onChange(value){
    // console.log('value', value)
    const { setQuickSelected } = this.props;
    // reset quick selected if range is changed using calendar
    setQuickSelected();
    this.setState({
      quickSelectedKey: [],
      value: [setStartOfTheDay(value[0]), setEndOfTheDay(value[1])],
      changed: true,
    })
  }
  clearFilter() {
    const { setQuickSelected } = this.props;
    // reset quick selected if range is cleared
    setQuickSelected();
    this.setState({
      value: [],
      quickSelectedKey: [],
      changed: true,
    });
  }
  applyFilter() {
    const { confirm, setSelectedKeys, isUIDateRangeFilter } = this.props;
    const { value, quickSelectedKey } = this.state;
    let selectedValues = [];
    if(!_.isEmpty(value)){
      if(!isUIDateRangeFilter){
        if(_.isEmpty(quickSelectedKey)){
          selectedValues = [
            value[0].utc().format(),
            value[1].utc().format()
          ]
        } else {
          selectedValues = [quickSelectedKey[0]];
        }
      }else{
        if(_.isEmpty(quickSelectedKey)){
          //to apply date range filter at frontend
          selectedValues = [`${value[0].valueOf()}-${value[1].valueOf()}`];
        } else {
          selectedValues = [quickSelectedKey[0]];
        }
      }
    }
    setSelectedKeys(selectedValues);
    confirm();
  }
  renderExtraFooter(){
    return (
        <div className="d-flex justify-content-flex-end">
          <div>
            <Button size="small" type="link" onClick={this.clearFilter} className="m-r-xs">Clear</Button>
            <Button type="primary" size="small" onClick={this.applyFilter} disabled={!this.state.changed}>Apply</Button>
          </div>
        </div>
    )
  }
  onQuickSelect(e){
    const { setQuickSelected } = this.props;
    const option = _.find(DateRangeQuickOptions, { label: e.key });
    if(!option){
      console.warn("Unknown option selected", e);
      return;
    }
    setQuickSelected(option.label);
    this.setState({
      value: getStartAndEndDateForQuickOption(option),
      quickSelectedKey: [e.key]
    }, this.applyFilter);
  }
  renderQuickOptions(){
    // const { quickOptions } = this.props;
    // if(!quickOptions){
    //   return null;
    // }
    return (
      <div>
      <Title className="p-l-m p-r-xs" level={5}>Common options</Title>
        <Menu onClick={this.onQuickSelect} selectedKeys={this.state.quickSelectedKey}>
          {
            _.filter(DateRangeQuickOptions, entry => !entry.isHidden).map(option => {
              return <Menu.Item className="m-y-0 ant-dropdown-menu-item" key={option.label}>{option.label}</Menu.Item>
            })
          }
        </Menu>
      </div>
    )
  }

  setPanelData(values, modes) {
    this.modes = modes;
  }

  disableFutureDates(current) {
    return disableFutureDates(current, this.modes); 
  }
  
  render() {
    const { value, invalidMessage } = this.state;
    const { visible, style, allowFutureDates = false } = this.props;

    return (
      <div className="column-filter column-filter-date-range">
        <div className="d-flex">
          {this.renderQuickOptions()}
          <div ref={this.ref} className="d-flex flex-column align-items-flex-end">
            <RangePicker
              onPanelChange={this.setPanelData}
              inputReadOnly
              allowClear={false}
              getPopupContainer={() => this.ref.current}
              value={value}
              open={visible}
              onChange={this.onChange}
              suffixIcon={null}
              disabledDate={!allowFutureDates && this.disableFutureDates}
              style={style}
              dropdownAlign={{
                points: ['tr', 'br'],
              }}
              renderExtraFooter={this.renderExtraFooter}
              placeholder={["Select Start Date", "Select End Date"]}
            />
          </div>
        </div>
        {
          invalidMessage && <span className="column-filter-list m-xs">Invalid/Out of range date</span>
        }
      </div>
    )
  }
}

export function disableFutureDates(current, modes = []){
  if (current) {
    const inputFields = document.querySelectorAll('.column-filter-date-range .ant-picker-input');
    // This detect the field for whom the panel is open
    const index = _.findIndex(inputFields, (field) => field.classList.contains('ant-picker-input-active'));
    let mode = modes[index];
    if (mode === 'date' || !mode) {
      mode = 'day';
    }
    return current.isAfter(moment(), mode);
  }
}

export default ColumnFilterDateRange;
